import { useMutation } from "@tanstack/react-query";
import { privateApi } from "../../../api/api";
import { CreateBankFormData } from "../schema/CreateBankSchema";
import { CreateBankResponseSchema } from "../response/CreateBankResponse";
import { ValidationErrorResponse } from "../../common/response/ValidationErrorResponse";

export const useCreateBank = () => {
    return useMutation({
        mutationFn: async (formData: CreateBankFormData) => await privateApi.post(`/v3/property-bank`, formData),
        onSuccess: async (response) => {
            try {
                const validationResult = CreateBankResponseSchema.safeParse(response.data);

                if (!validationResult.success) {
                    console.error("Validation failed:", validationResult.error.errors);
                    throw new Error("Invalid property bank data format");
                }

                return validationResult.data
            } catch (error) {
                console.error('Failed to create property bank', error);
                throw error;
            }
        },
        onError: (error) => {
            const validationResult = ValidationErrorResponse.safeParse((error as any).response.data);

            if (!validationResult.success) {
                console.error("Validation failed:", validationResult.error.errors);
                throw new Error("Invalid property bank data format");
            } else {
                console.error(`Failed to create property bank`, error);
                throw error;
            }
        }
    });
};